<template>
  <div class=" ">
    <v-img :src="require('@/assets/image/17545.jpg')" height="100vh">
      <section>
        <v-card flat style="background: transparent;">
          <v-card-text class="pa-0">
  
            <v-row 
              style="height: 100vh;">
              <v-col 
                cols="12"
                md="12"
                style="height: 100%; display: flex; align-items: center; justify-content: center;">
                <v-card
                  flat
                  style="width: 80%; height: 600px; border-radius: 6px;">
                  <v-row style="width: 100%;">
                    <v-col cols="12" md="6" class="py-0">
                      <v-img :src="require('@/assets/image/bg.png')" height="600">
                        <v-img
                          :src="require('@/assets/image/onboard.png')"
                          contain
                          style="width: 100%; height: 100%;"
                          class="border-radius">
                        </v-img>
                      </v-img>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-card-text class=" d-flex justify-center align-center" style="height: 100%; width: 100%;">
                        <div style="width: 85%;">
                          <v-card
                            flat
                            height="100%"
                            color="#FFFFFFB2"
                            class="border-radius">
                            <v-card-text
                              class="">
                              <div class="mb-8">
                                <v-img
                                  :src="require('@/assets/logo/logo.png')"
                                  contain
                                  class="ml-auto mr-auto"
                                  style="width: 60%;">
                                </v-img>
                              </div>
                              <!-- <div
                                class="mb-2">
                                <div
                                  class="fs-18 black_one font-weight-bold black--text mb-0">
                                  Masuk Admin
                                </div>
                              </div> -->
        
                              <ValidationObserver 
                                ref="observer">
                                <v-form class="text-left mb-0">
                                  <div class="fs-14 mb-1 black_two">
                                    Email
                                  </div>
                                  <ValidationProvider 
                                    name="Email" 
                                    rules="required" 
                                    v-slot="{ errors }">
                                    <v-text-field
                                      v-on:keyup.enter="save"
                                      class="no_box"
                                      solo
                                      rounded
                                      dense
                                      single-line
                                      
                                      :color="'#4FA0CB'"
                                      style="border-radius: 4px;"
                                      placeholder="Masukan email yang telah didaftarkan"
        
                                      vv-uppercase
        
                                      v-model="form.email"
                                      :error-messages="errors"
                                      required>
                                    </v-text-field>
                                  </ValidationProvider>
        
                                  <div class="fs-14 mb-1 black_two">
                                    Kata Sandi
                                  </div>
                                  <ValidationProvider 
                                    name="password" 
                                    rules="required|min:5|max:30" 
                                    v-slot="{ errors }">
                                    <v-text-field
                                      v-on:keyup.enter="save"
                                      class="no_box"
                                      solo
                                      rounded
                                      dense
                                      single-line
                                      
                                      :color="'#4FA0CB'"
                                      style="border-radius: 4px;"
                                      placeholder="Masukan kata sandi"
                                      :type="show ? 'text' : 'password'"
                                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                      @click:append="show = !show"
                                      :counter="30"
        
                                      vv-uppercase
                                      
                                      v-model="form.password"
                                      :error-messages="errors"
                                      required>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-form>
                              </ValidationObserver>
        
                              <div 
                                class="text-center mb-6">
                                <div v-if="message.error.length > 0"
                                  class="text-center my-4">
                                  <div
                                    class="error--text d-flex align-start">
                                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                                    
                                    <span
                                      class="ml-1">
                                      {{ message.error }}
                                    </span>
                                  </div>
                                </div>
        
                                <!-- <div class="blue_one fs-14 text-right mt-1 mb-5" style="font-weight: 600;">
                                  <span class="cursor-pointer">Lupa Kata Sandi</span>
                                </div> -->
        
                                <v-btn
                                  :disabled="process.form"
                                  :loading="process.form"
                                  @click="save()"
                                  block
                                  color="#4FA0CB"
                                  width="170"
                                  height="40"
                                  elevation="0"
                                  class="fs-15 font-weight-bold white--text text-capitalize border-radius mt-5">
                                  Masuk Pegawai
                                </v-btn>
        
                                <!-- <div class="text-center fs-14 my-10">
                                  <span class="black_two">Belum punya akun? </span>
                                  <span class="blue_one cursor-pointer" @click="toRegister()">Daftar</span>
                                </div> -->
                              </div>
                            </v-card-text>
                          </v-card>
                        </div>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </section>
    </v-img>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          email: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      
    },
    methods: {

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('pegawai/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              // console.log(res.results.data)
              let user = res.results.data,
                  menu_arr = res.results.data.category_menu_array.length < 1 ? [] : res.results.data.category_menu_array,
                  // menu_arr = [],
                  menu_default = [
            {
              id: 1,
              label: 'Dashboard',
              icon: require('@/assets/icon/dashboard.png'),
              link: '/dashboard',
              active: true,
              status: true,
              is_child: true,
              sub_menu: [
                {
                  id: 2,
                  label: 'Statistik',
                  icon: require('@/assets/icon/grafik.png'),
                  link: '/dashboard',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 3,
                  label: 'Monitoring',
                  icon: require('@/assets/icon/consultant.png'),
                  link: '/dashboard/monitoring',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 4,
                  label: 'Audit Trail',
                  icon: require('@/assets/icon/audit.png'),
                  link: '/dashboard/audit-trail',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                }
              ]
            },
            {
              id: 5,
              label: 'Data Sekolah',
              icon: require('@/assets/icon/school.png'),
              link: '/sekolah',
              active: true,
              status: true,
              is_child: true,
              sub_menu: [
                {
                  id: 6,
                  label: 'Sekolah',
                  icon: require('@/assets/icon/school-gedung.png'),
                  link: '/sekolah/data-sekolah',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 7,
                  label: 'Tahun Ajaran',
                  icon: require('@/assets/icon/calendar.png'),
                  link: '/sekolah/tahun-ajaran',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 26,
                  label: 'Jabatan',
                  icon: require('@/assets/icon/employment.png'),
                  link: '/sekolah/jabatan',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 27,
                  label: 'Hak Akses Guru & Pegawai',
                  icon: require('@/assets/icon/users.png'),
                  link: '/sekolah/hak-akses-guru-pegawai',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                },
              ]
            },
            {
              id: 8,
              label: 'Manajemen Akademik',
              icon: require('@/assets/icon/learning.png'),
              link: '/manajemen-akademik',
              active: true,
              status: true,
              is_child: true,
              sub_menu: [
                {
                  id: 9,
                  label: 'Data Pengguna',
                  icon: require('@/assets/icon/instructor.png'),
                  link: '/manajemen-akademik/data-pengguna',
                  active: false,
                  status: true,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 11,
                      label: 'Guru & Pegawai',
                      icon: require('@/assets/icon/instructor.png'),
                      link: '/manajemen-akademik/data-pengguna/data-guru',
                      active: false,
                      status: true,
                      is_child: true,
                      sub_menu: [
                        {
                          id: 28,
                          label: 'Data Guru & Pegawai',
                          icon: require('@/assets/icon/instructor.png'),
                          link: '/manajemen-akademik/data-pengguna/data-guru-pegawai',
                          active: false,
                          status: true,
                          is_child: false,
                          sub_menu: []
                        },
                        {
                          id: 29,
                          label: 'Guru Pengampu',
                          icon: require('@/assets/icon/instructor.png'),
                          link: '/manajemen-akademik/kelas-jadwal/bidang-studi',
                          active: false,
                          status: true,
                          is_child: false,
                          sub_menu: []
                        },
                      ]
                    },
                    {
                      id: 12,
                      label: 'Data Siswa',
                      icon: require('@/assets/icon/instructor.png'),
                      link: '/manajemen-akademik/data-pengguna/data-siswa',
                      active: false,
                      status: true,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 13,
                      label: 'Data Wali Murid',
                      icon: require('@/assets/icon/instructor.png'),
                      link: '/manajemen-akademik/data-pengguna/data-wali-murid',
                      active: false,
                      status: true,
                      is_child: false,
                      sub_menu: []
                    }
                  ]
                },
                {
                  id: 10,
                  label: 'Kelas & Jadwal ',
                  icon: require('@/assets/icon/period.png'),
                  link: '/manajemen-akademik/kelas-jadwal',
                  active: false,
                  status: true,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 14,
                      label: 'Kelola Kelas',
                      icon: require('@/assets/icon/period.png'),
                      link: '/manajemen-akademik/kelas-jadwal/kelola-kelas',
                      active: false,
                      status: true,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 15,
                      label: 'Jadwal Pembelajaran',
                      icon: require('@/assets/icon/period.png'),
                      link: '/manajemen-akademik/kelas-jadwal/jadwal-pembelajaran',
                      active: false,
                      status: true,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 16,
                      label: 'Kalender Akademik',
                      icon: require('@/assets/icon/period.png'),
                      link: '/manajemen-akademik/kelas-jadwal/kalender-akademik',
                      active: false,
                      status: true,
                      is_child: false,
                      sub_menu: []
                    }
                  ]
                },
                {
                  id: 17,
                  label: 'Kurikulum Sekolah',
                  icon: require('@/assets/icon/curriculum.png'),
                  link: '/manajemen-akademik/kurikulum-sekolah',
                  active: false,
                  status: true,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 18,
                      label: 'Daftar Mata Pelajaran',
                      icon: require('@/assets/icon/curriculum.png'),
                      link: '/manajemen-akademik/kelas-jadwal/daftar-mata-pelajaran',
                      active: false,
                      status: true,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 19,
                      label: 'Upload & Kelola Modul ',
                      icon: require('@/assets/icon/curriculum.png'),
                      link: '/manajemen-akademik/kurikulum-sekolah/upload-kelola-modul',
                      active: false,
                      status: true,
                      is_child: false,
                      sub_menu: []
                    },
                  ]
                }
              ]
            },
            {
              id: 26,
              label: 'Kehadiran',
              icon: require('@/assets/icon/timetable.png'),
              link: '/manajemen-akademik/kehadiran',
              active: true,
              status: true,
              is_child: true,
              sub_menu: [
                {
                  id: 27,
                  label: 'Kehadiran Guru & Pegawai',
                  icon: require('@/assets/icon/dash_program.png'),
                  link: '/manajemen-akademik/kehadiran/kehadiran-guru-pegawai',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 28,
                  label: 'Kehadiran Siswa',
                  icon: require('@/assets/icon/lembur.png'),
                  link: '/manajemen-akademik/kehadiran/kehadiran-siswa',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                }
              ]

            },
            {
              id: 20,
              label: 'Pengaturan Sistem ',
              icon: require('@/assets/icon/setting.png'),
              link: '/pengaturan-sistem',
              active: true,
              status: true,
              is_child: true,
              sub_menu: [
                {
                  id: 21,
                  label: 'Home Banner',
                  icon: require('@/assets/icon/slider.png'),
                  link: '/pengaturan-sistem/home-banner',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 22,
                  label: 'Hak Akses',
                  icon: require('@/assets/icon/user-list.png'),
                  link: '/pengaturan-sistem/hak-akses',
                  active: false,
                  status: true,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 23,
                      label: 'Data Admin',
                      icon: require('@/assets/icon/user-list.png'),
                      active: false,
                      status: true,
                      is_child: false,
                      link: '/pengaturan-sistem/hak-akses/data-admin',
                      sub_menu: []
                    },
                    {
                      id: 24,
                      label: 'Role Admin',
                      icon: require('@/assets/icon/user-list.png'),
                      active: false,
                      status: true,
                      is_child: false,
                      link: '/pengaturan-sistem/hak-akses/role-admin',
                      sub_menu: []
                    }
                  ]
                },
                {
                  id: 25,
                  label: 'Dokumen Legal',
                  icon: require('@/assets/icon/doc.png'),
                  link: '/pengaturan-sistem/dokumen-legal',
                  active: false,
                  status: true,
                  is_child: false,
                  sub_menu: []
                },
              ]
            }
          ]
              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu_arr.length > 0 ? menu_arr : menu_default)
              )

              TokenService.saveReload(false)

              TokenService.saveColor(
                '#4FA0CB'
              )

              this.$store.commit("setColor", '#4FA0CB')

              window.location = `${process.env.BASE_URL}`
              

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>